// Port of api/fuel/app/classes/filter/search/games/filters/query/game/version/worth.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'version.worth',
	priority: 65,
	require: function(config, filter) { return filter.version && rangeActive(filter.version.worth, 0, 99999) },
	run: function(config, filter, data, query) {
		if (filter.version.worth.from > 0) query.where('v.game_version_worth_value', '>=', filter.version.worth.from)
		if (filter.version.worth.to < 99999) query.where('v.game_version_worth_value', '<=', filter.version.worth.to)
	}
}
